module.exports = __webpack_public_path__ + "static/media/IC_data_template.66d552ca.svg";